<template>
    <section class="chart-container" >
        <div class=" ml30 mr30" >
            <!--记录查询页 s-->
                <div class=" mb15 row flex-start">
                    <div class="row flex-start"><div>场地名称：</div>
                    <el-select ref="selectValue1" v-model="optionValue" @change="optionValueChange" filterable placeholder="请选择" class="mr25">
                        <el-option
                                v-for="item in optionList"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value"
                        />
                    </el-select>
                    </div>
                </div>

                <div class="row flex-between mt15 mb15">
                    <div class="row flex-start">
                        <div class=" row flex-center font24 grey6_text cursorp white_bg mr15"  @click="onEdit('new')" style="width:180px;height:60px;border: 1px solid rgba(227, 232, 238, 1);">新增</div>
                        <div class=" row flex-center font24 grey6_text cursorp white_bg mr15"  @click="onEdit()" style="width:180px;height:60px;border: 1px solid rgba(227, 232, 238, 1);">编辑</div>
                        <div class=" row flex-center font24 grey6_text cursorp white_bg mr15"  @click="editFuc('ENABLE')" style="width:180px;height:60px;border: 1px solid rgba(227, 232, 238, 1);">启用</div>
                        <div class=" row flex-center font24 grey6_text cursorp white_bg mr15"  @click="editFuc('DISABLE')" style="width:180px;height:60px;border: 1px solid rgba(227, 232, 238, 1);">禁用</div>
                    </div>
                </div>


                <template>
                    <el-table  v-loading = "isLoading"  element-loading-background = "rgba(255, 255, 255, .5)"  :element-loading-text = "loadText"  element-loading-spinner = "el-icon-loading"  :height="recoData.recParams.page_size==10?570:570"  :data="recoData.list"  id="ExportExcelTable"   :row-style="rowStyle"  @row-click="changeCurrentRow">
<!--                            <el-table-column  :prop="item.Key"  :label="item.Value"   v-for="(item,index) in recoData.setData" :key="index" >-->
<!--                            </el-table-column>-->
                        <el-table-column
                                prop="PlateNo"  width="120"
                                label="车号">
                        </el-table-column>
                        <el-table-column
                                prop="VehicleWeight"
                                label="车辆皮重">
                        </el-table-column>
                        <el-table-column
                                prop="Driver"
                                label="驾驶员">
                        </el-table-column>
                        <el-table-column
                                prop="DriverPhone"  width="120"
                                label="驾驶员手机">
                        </el-table-column>
                        <el-table-column
                                prop="customer"
                                label="所属客户">
                        </el-table-column>
                        <el-table-column
                                prop="begindate"  width="180"
                                label="有效期开始日期">
                        </el-table-column>
                        <el-table-column
                                prop="enddate"  width="180"
                                label="有效期结束日期">
                        </el-table-column>
                        <el-table-column
                                prop="Comment"
                                label="备注">
                        </el-table-column>
                        <el-table-column
                                prop="Valid"
                                label="启用/禁用">

                            <template slot-scope="scope">
                                <span v-if="scope.row.Valid == 1" class="green_text">已启用</span>
                                <span v-if="scope.row.Valid == 0" class="red_text">已禁用</span>
                            </template>
                        </el-table-column>
                    </el-table>
                     <div class="row flex-between">
                         <div></div>
                         <div class="row flex-start font12">
                             <el-pagination background layout="total,sizes,prev, pager, next"     :page-size="recoData.recParams.page_size"  :page-sizes="[10,20,30,40,50,100,200,500,1000,2000]" :total="recoData.total"  popper-class='select_bottom'
                                           v-model:currentPage="recoData.recParams.page" v-model:page-size="recoData.recParams.page_size"
                                           @current-change="handleCurrentChange" @size-change="handleSizeChange" style="margin: 20px 0 20px 0;" />
                         </div>
                     </div>
                </template>
            <!--记录查询页 e-->

            <!--编辑弹窗-->
            <el-dialog :title="title" :visible.sync="show01"  @closed="handleClose" :close-on-click-modal="false"  append-to-body="true" >
                <el-form :model="form" :rules="rules" ref="ruleForm" label-position="top">
                    <el-row :gutter="20">
                        <el-col :span="12">
                            <el-form-item :label="recoData.currentRowId?'车牌号(车牌号码不允许修改录错了请禁用)':'车牌号'"  prop="PlateNo">
                                <el-input v-model="form.PlateNo" :disabled="recoData.currentRowId?true:false"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="车辆皮重" prop="VehicleWeight">
                                <el-input v-model="form.VehicleWeight" onkeyup="value=value.replace(/[^\d^\.]+/g,'')"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20">
                        <el-col :span="12">
                            <el-form-item label="驾驶员"  prop="Driver">
                                <el-input v-model="form.Driver"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="驾驶员手机"  prop="DriverPhone">
                                <el-input v-model="form.DriverPhone"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-form-item label="所属客户"  prop="CarOwner">
                        <el-select v-model="form.CarOwner" placeholder="请选择所属客户">
                            <el-option
                                    v-for="item in CarOwnerList"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="有效期" >
                        <el-date-picker type="datetime" placeholder="选择日期" v-model="form.begindate"></el-date-picker> ~
                        <el-date-picker type="datetime" placeholder="选择日期" v-model="form.enddate"></el-date-picker>
                    </el-form-item>
                    <el-form-item label="备注">
                        <el-input type="textarea" v-model="form.Comment"></el-input>
                    </el-form-item>
                </el-form>
                <div slot="footer" class="dialog-footer">
                    <el-button @click="show01 = false">取 消</el-button>
                    <el-button type="primary" @click="editFuc('NEW')" v-if="title=='新增车辆'">确 定</el-button>
                    <el-button type="primary" @click="editFuc()" v-else>确 定</el-button>
                </div>
            </el-dialog>

        </div>
    </section>
</template>

<script>
    import axios from "axios";
    import { showLoading, hideLoading } from '../utils/common.js';
    import  {get_date_time,checktel}  from '../utils/date.js';

    export default {
        data() {
            return {
            CarOwnerList:[],//所属客户列表
                optionList: [],
                optionValue: '',
                user: JSON.parse(window.localStorage.getItem('user')),
                isLoading:false,//表格加载
                loadText:'正在加载…请耐心等待',
                loadText1:'正在加载…请耐心等待',
                loadText2:'数据比较多正在加载…请耐心等待',
                recoData:{
                    currentRowId:'',//当前选中行的id
                    list:[],//表格list
                    total:0,//表格toal
                    keywords:'',
                    recParams:{
                        machine_code:'',
                        page_size:10,
                        page:1,
                    },
                },

                show01:false,//编辑弹窗
                form:{
                    PlateNo: '',
                    Driver: '',
                    DriverPhone: '',
                    Comment: '',
                    CarOwner: '',
                    begindate:'',
                    enddate:'',
                    VehicleWeight:''
                },
                title:'编辑车辆',

                rules: {
                  PlateNo:{ required: true, message: '请输入车牌号', trigger: 'blur' },
                  Driver:{ required: true, message: '请输入驾驶员', trigger: 'blur' },
                },
            }
        },

        mounted: function () {
            this.resetData()
  		    this.getoptionList()
        },
        methods: {
//记录查询页 s
        optionValueChange(e){
                    this.onRefresh2()
        },
         resetData() {
                this.recoData.currentRowId=''
                this.recoData.list=[];
                this.recoData.total=0;
                this.recoData.keywords='';
                this.recoData.recParams.page=1;
                this.recoData.recParams.page_size=10;
        },
         onRefresh2() {
            this.resetData()
            this.getRecoredList()
         },


handleClose () {
     // this.$refs.ruleForm.resetFields()
    },





          onEdit(e){
            if(this.recoData.currentRowId==''&&e!='new'){
            return;
            }
            if(e=='new'){
            this.title="新增车辆"
            this.recoData.currentRowId=''
             this.form = {
                    PlateNo: '',
                    Driver: '',
                    DriverPhone: '',
                    Comment: '',
                    CarOwner: '',
                    begindate:'',
                    enddate:'',
                    VehicleWeight:''
              }
            }else{
            this.title="编辑车辆"
            //this.getDetail()
            }
            this.show01=!this.show01
            let self=this
            let recParams={}
            recParams.machine_code=self.optionValue
            self.$axios.get(this.baseApiUrl+'appointment/customer_list',{"params": recParams}).then(function (res) {
                    if(res.data.code==1){
                        self.CarOwnerList=res.data.data
                         let CarOwnerList = self.CarOwnerList.map(t => {
                            return {
                               value: t.uuid,
                                label:t.Name
                               }
                             })
                             self.CarOwnerList=CarOwnerList
                    }
              })

            },
editFuc(ValidVal){//编辑接口
let self=this

let params={'model':'car','uuid':this.recoData.currentRowId,
'PlateNo':self.form.PlateNo,
'Driver':self.form.Driver,
'DriverPhone':self.form.DriverPhone,
'CarOwner':self.form.CarOwner,
'Comment':self.form.Comment,
'begindate':get_date_time(self.form.begindate),
'enddate':get_date_time(self.form.enddate),
'VehicleWeight':self.form.VehicleWeight
}
let params2={'model':'car','uuid':this.recoData.currentRowId,'Valid':ValidVal=='ENABLE'?1:0}
let params3={'machine_code':self.optionValue,Id:'','Valid':1,
'PlateNo':self.form.PlateNo,
'Driver':self.form.Driver,
'DriverPhone':self.form.DriverPhone,
'CarOwner':self.form.CarOwner?self.form.CarOwner:0,
'Comment':self.form.Comment,
'begindate':get_date_time(self.form.begindate),
'enddate':get_date_time(self.form.enddate),
'VehicleWeight':self.form.VehicleWeight
}
let paramsV=ValidVal=='NEW'?params3:(ValidVal=='ENABLE'||ValidVal=='DISABLE')?params2:params
let textV=ValidVal=='NEW'?'新增成功':ValidVal=='ENABLE'?'已启用':ValidVal=='DISABLE'?'已禁用':'编辑成功'
               if(ValidVal=='ENABLE'||ValidVal=='DISABLE'){
                    if(this.recoData.currentRowId==''){
                    return;
                    }
                    let text=ValidVal=='ENABLE'?'是否确认启用？':'是否确认禁用？'
                   this.$confirm(text, '提示', {
                          confirmButtonText: '确定',
                          cancelButtonText: '取消',
                          type: 'warning',
                          center: true
                    }).then(() => {
                    self.editApi(paramsV,textV)
                    })
                }
                else{

      this.$refs.ruleForm.validate((valid) => {

      if (valid) {
                 if(self.form.DriverPhone.length>0&&!checktel(self.form.DriverPhone)){
                    self.$message({type: 'warn',message: '手机输入错误'});
                    return;
                }
                if(self.form.begindate==''){
                    self.$message({type: 'warn',message: '请选择开始时间'}); return;
                }
                if(self.form.enddate==''){
                    self.$message({type: 'warn',message: '请选择结束时间'}); return;
                }


                       if(ValidVal=='NEW'){
                        console.log("新增方法")
                        self.addApi(paramsV,textV)
                    }else{
                        console.log("编辑方法")

                        self.editApi(paramsV,textV)
                    }

                }
      });
         }
},

editApi(paramsV,textV){
        let self=this
        self.$axios.post(self.baseApiUrl+'account4/machine_data/machine_data/edit',paramsV).then(function (res) {
          self.show01 = false
         if(res.data.code==1){
            self.$message({type: 'success',message: textV});
            self.onRefresh2()
         }
        })
},


addApi(paramsV,textV){
        let self=this
        self.$axios.post(self.baseApiUrl+'account4/admin/car/add',paramsV).then(function (res) {
          self.show01 = false
         if(res.data.code==1){
            self.$message({type: 'success',message: textV});
            self.onRefresh2()
         }
        })
},

         getRecoredList(e){
         let self=this
            self.isLoading = true;
         let recParams=self.recoData.recParams
         if(recParams.page_size>100){
         self.loadText=self.loadText2
         }else{
         self.loadText=self.loadText1
         }
         recParams.machine_code=self.optionValue
               this.$axios.get(this.baseApiUrl+'appointment/list_car',{"params": recParams}).then(function (res) {
                self.isLoading = false;
                if(res.data.code==1){
                    self.recoData.list=res.data.data.filter(function (i) {
                             return i.Valid!= 0;
                            });
                                            }


            })
        },



        handleSizeChange (val) {
            this.recoData.recParams.page_size = val
            this.getRecoredList()
        },
        handleCurrentChange  (val) {
            this.recoData.recParams.page = val
            this.getRecoredList()
        },










            changeCurrentRow(row, column, event) {
              if (this.recoData.currentRowId === row.uuid){
              this.recoData.currentRowId = ''
              }else{
              this.recoData.currentRowId = row.uuid
              this.form = row
              }
            },
            rowStyle ({row, rowIndex}) {
              if (this.recoData.currentRowId === row.uuid) {
                // 此处返回选中行的样式对象，按需设置
                return {
                  'background-color': '#e3e8ee',
                }
              }
            },

//记录查询页 e
getoptionList(){
let self=this
 let machparam={type:2}
        self.$axios.post(self.baseApiUrl+'rsa/get_machine_code_list',machparam).then(function (res) {
            console.log("get_machine_code_list-res")
            console.log(res.data.data)
            let resdata=res.data.data
            let optionList = resdata.map(t => {
            return {
               value: t.machine_code,
                label:t.remark
               }
             })
            console.log("optionList")
            console.log(optionList)
            self.optionList=optionList

                let machparam1={type:1}
                self.$axios.post(self.baseApiUrl+'rsa/get_machine_code_list',machparam1).then(function (res) {
                    console.log("get_machine_code_list-res2")
                    console.log(res.data.data)
                    let resdata2=res.data.data
                    let optionList2 = resdata2.map(t => {
                        return {
                            value: t.machine_code,
                            label:t.remark
                           }
                     })
                    self.optionList=self.optionList.concat(optionList2)
                    self.optionValue=self.optionList[0].value
                    self.getRecoredList()

                })

        })
        },





//自动审核开启关闭
editAutoAuditConfig2(){
    let self=this;

    let params={
    is_auto_audit:self.checked?1:0,
    auto_audit_begin_time:self.auto_audit_time?self.auto_audit_time[0]:'',
    auto_audit_end_time:self.auto_audit_time?self.auto_audit_time[1]:'',
    account6_uid:''
    }

    if(self.checked){//关闭
               this.$confirm('是否确认关闭自动审核？', '提示', {
                      confirmButtonText: '确定',
                      cancelButtonText: '取消',
                      type: 'warning',
                      center: true
                }).then(() => {

        this.$axios.post(this.baseApiUrl+'appointment/editAutoAuditConfig',params).then(function (res) {
            console.log("editAutoAuditConfig2-关")
            if(res.code==1){
                self.checked=false
                self.$message({type: 'success',message: '提交成功!'});
                self.onRefresh()
            }
        })
})
    }else{//开启
      if(!self.auto_audit_time||self.auto_audit_time.length==0){
             this.$alert('请先选择时间', {
                 confirmButtonText: '确定',
            });
            return;
        }
this.$axios.post(this.baseApiUrl+'appointment/editAutoAuditConfig',params).then(function (res) {
        console.log("editAutoAuditConfig2-开")
        console.log(res)
    if(res.code==1){
         self.checked=true
        self.$message({type: 'success',message: '提交成功!'});
        self.onRefresh()
        }
})


    }


},



        }

    }
</script>

<style lang="scss"></style>



// WEBPACK FOOTER //
// Car.vue?a6d8839a